/***
* Add by hxzhu
* created:20190805
* 注:营销活动支付界面
*/
<template>
  <div class="orderpage">
    <div class="pay">
      <div style="color:black;font-size:0.5rem;float:left;font-family:'Microsoft YaHei';">支付金额
      </div>
      <div style="font-size:0.5rem;float:right;">
        <span>{{orderInfo.buyNum*orderInfo.totalMoney}}</span>元
      </div>
    </div>
      <ul>
        <li>
          商品名称：
          <span>{{orderInfo.actName}}</span>
        </li>
        <li>
          订单编号：
          <span>{{orderInfo.orderId}}</span>
        </li>
        <li>
          商家名称：
          <span>{{orderInfo.merName}}</span>
        </li>
        <li>
          商品数量：
          <span>{{orderInfo.buyNum}}</span>
        </li>
        <li style="margin-bottom: 0.35rem;">
          商品价格：
          <span>{{orderInfo.totalMoney}}</span>
        </li>
      </ul>
    <div style="width:100%;height:4vh;font-size: 0.4rem;line-height:4vh;font-family:'Microsoft YaHei';padding-left: 3vw">支付方式</div>
    <div style="background-color: white;padding-left: 3vw;height:8vh;    display: flex;
    flex-direction: row;align-items: center">
      <img src="../../resource/img/pay_icon_wechat.png" style="width:0.8rem;height:0.8rem;top:8px;"/>
      <div style="margin-left:3vw;font-size: 0.4rem;">微信支付</div>
    </div>
    <div style="height:20vh;width:100%;"></div>
    <div class="btn_pay" @click="btnpay">确认支付<span>{{orderInfo.buyNum*orderInfo.totalMoney}}</span>元<source/>
    </div>
  </div>
</template>
<script>
  let activityIds;
  let uids;
  let wechatUrl;
  export default {
    name: "MerUnionPay",
    data() {
      return {
        orderInfo: [],
        openid: "",
        wechatUrl: "http://h5.store.mbscloud.cn",
        //wechatUrl: "http://testh5.mbspt.com"
      };
    },
    created() {
      let that = this;
      that.findSiteUrl();
      if (that.$route.query.orderInfo) {
        that.orderInfo = JSON.parse(that.$route.query.orderInfo);
        if (that.orderInfo.paid == 1) {
          that.$router.push({
            path: "/MerTokerDetail",
            query: {
              activityId: that.orderInfo.activitydata,
              merId: that.orderInfo.merId,
              price: that.orderInfo.totalMoney,
              storeId: that.orderInfo.storeId
            }
          });
        }
        that.openid = that.$route.query.openid;
        activityIds = that.orderInfo.activityId;
        uids = that.orderInfo.uid;
      }
    },
    methods: {
      btnpay: function () {
        let that = this;
        that.$axios
          .post(
            "/merchant/api/activity/merchant-market-extend/pay",
            that.$qs.stringify({
              merId: that.orderInfo.merId,
              out_trade_no: that.orderInfo.orderId,
              body: that.orderInfo.actName,
              total_fee: that.orderInfo.totalMoney,
              uid: that.orderInfo.uid,
              activityId: that.orderInfo.activityId,
              openid: that.openid
            })
          )
          .then(response => {
            //调取微信支付接口
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: response.data.data.appid,
                timeStamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: response.data.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: response.data.data.sign // 支付签名
              },
              function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  window.location.href = wechatUrl +
                    "/MerTokerOrder?activityId=" +
                    activityIds +
                    "&uid=" +
                    uids + "&type=1";
                } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  alert("你已经取消订单支付");
                } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                  alert("订单交易失败");
                }
              }
            );
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error);
          });
      },
      //获取网站的信息
      findSiteUrl: function () {
        let that = this;
        that.$axios
          .post(
            "/system/config/find/site/url",
          )
          .then(response => {
            if (response.data.code == 1) {
              if (response.data.data != null) {
                let map = response.data.data;
                if (map.wxSiteUrl != null) {
                  this.wechatUrl = map.wxSiteUrl;
                }
                wechatUrl = this.wechatUrl;
              }
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error);
          });
      },
    }
  };
</script>

<style scoped>
  .orderpage {
    width: 100vw;
    height: 100vh;
    background-color: #fefafa;
    margin-top: 50px;
  }

  .pay {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 8%;
    border: 2px dashed #f3a623;
    color: #f3a623;
    padding-left: 3vw;
    padding-right: 3vw;
  }


  ul {
    width: 100vw;
    background-color: white;
    text-align: left;
    list-style: none;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-content: center;
  }

  ul li {
    margin-top: 0.35rem;
    font-size: 0.4rem;
    font-family: "Microsoft YaHei";
    padding-left: 3vw;
  }

  .btn_pay {
    margin-top: 0.266667rem;
    width: 75vw;
    height: 4vh;
    background: rgba(245, 166, 35, 1);
    border-radius: 10px;
    text-align: center;
    line-height: 4vh;
    border: 0.2rem solid #f3a623;
    margin-left: 13%;
    font-size: 20px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerPay.vue